// extracted by css-extract-rspack-plugin
export default {"StyledTableRow":"table-row-module__StyledTableRow__U5HlV"};